import { render, staticRenderFns } from "./SingleTrip.vue?vue&type=template&id=06b3c3dc&scoped=true&"
import script from "./SingleTrip.vue?vue&type=script&lang=js&"
export * from "./SingleTrip.vue?vue&type=script&lang=js&"
import style0 from "./SingleTrip.vue?vue&type=style&index=0&id=06b3c3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3c3dc",
  null
  
)

export default component.exports